import styled from "styled-components";


export const HeroContainer = styled.div`
  background: transparent;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 48px 0 72px;
  overflow: hidden;
  @media (max-width: 960px) {
    padding: 32px 0 56px;
  }
  @media (max-width: 640px) {
    padding: 24px 0 40px;
  }
  z-index: 1;
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1440px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: min(1440px, 100%);
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 48px;
  box-sizing: border-box;
  gap: 40px;
  min-width: 0;

  @media (max-width: 960px) {
    flex-direction: column;
    gap: 24px;
  }
  @media (max-width: 640px) {
    padding: 0 16px;
  }
`;
export const HeroLeftContainer = styled.div`
  flex: 1;
  min-width: 0;
  width: auto;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export const HeroRightContainer = styled.div`
  flex: 0 1 420px;
  width: auto;
  min-width: 0;
  display: flex;
  order: 2;
  justify-content: flex-end;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    flex-basis: auto;
  }
`;

export const Img = styled.img`
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1;        /* keeps perfect circle */
  object-fit: cover;         /* fits ANY image size */
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};

  @media (max-width: 768px) {
    max-width: 350px;
  }

  @media (max-width: 640px) {
    max-width: 280px;
  }
`;


export const Title = styled.h1`
  font-weight: 700;
  font-size: clamp(32px, 8vw, 50px);
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.25;
  margin: 0;
  max-width: 100%;
  @media (max-width: 960px) {
    text-align: center;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: clamp(20px, 4vw, 32px);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.4;
  margin-top: 12px;
  max-width: 100%;
  @media (max-width: 960px) {
    justify-content: center;
    text-align: center;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const SubTitle = styled.p`
  font-size: clamp(15px, 2.4vw, 20px);
  line-height: 1.6;
  margin: 18px 0 32px;
  max-width: 560px;
  color: ${({ theme }) => theme.text_primary + 95};

  @media (max-width: 960px) {
    text-align: center;
  }
`;

export const ResumeButton = styled.a`
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 300px;
    text-align: center;
    padding: 16px 0;
    color:${({ theme }) => theme.white};
    border-radius: 20px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    transition: all 0.2s ease-in-out !important;
    background: hsla(271, 100%, 50%, 1);
    background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    background: -moz-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    background: -webkit-linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    box-shadow: 0 14px 30px rgba(109, 40, 217, 0.28);
    &:hover {
        transform: scale(1.04);
        transition: all 0.4s ease-in-out;
        box-shadow: 0 18px 36px rgba(109, 40, 217, 0.36);
        filter: brightness(1.03);
    }    
    
    
    @media (max-width: 640px) {
        padding: 12px 0;
        font-size: 18px;
    } 

`;
